import { PeekStat } from '../peek/peek-panel.models';
import { ShSeverity } from '@seahorse/components';

/**
 * One entry in the detail header's key-facts row (design handoff, "Step 7,
 * streamlined", section 1): the same label/value/emphasis shape as the
 * peek's stats strip, so both share one model. At most five are shown.
 *
 * Supply facts most important first: when they don't fit the header's width
 * they are hidden from the end, and remain reachable through the "+N" popover.
 */
export type KeyFact = PeekStat;

/** The detail header's status tag: a label (translation key or text) and a tag severity. */
export interface DetailStatus {
  label: string;
  severity: ShSeverity;
}

/** The most facts the header shows. */
export const MAX_KEY_FACTS = 5;

/**
 * Which facts wrapped onto the header's invisible second line: those whose
 * `offsetTop` is at or below the facts row's height. Returns their indexes,
 * in order. Pure, so it can be tested without a layout engine.
 */
export function hiddenFactIndexes(
  offsetTops: number[],
  rowHeight: number
): number[] {
  const result: number[] = [];
  offsetTops.forEach((top, index) => {
    if (top >= rowHeight) {
      result.push(index);
    }
  });
  return result;
}
